import { Projects } from '../types';
import { escapeHtml, sanitizeUrl } from '../utils/security';
import { sectionHeader } from './common';

export function buildProjects(projects: Projects) {
    const root = document.querySelector('[data-section="projects"]');
    if (!root) return;

    const itemsHtml = projects.items.map(item => {
        const linksHtml = item.links.map(l => `
            <a href="${sanitizeUrl(l.url)}"
               target="_blank"
               rel="noopener"
               class="inline-flex items-center gap-2 font-mono text-[11px] font-semibold tracking-[1px] uppercase text-sunset-dark hover:text-graphite transition-colors"
               aria-label="${escapeHtml(l.label)} (åpnes i ny fane)">
                ${escapeHtml(l.label)} <i data-lucide="arrow-up-right" stroke-width="2" class="w-3 h-3"></i>
            </a>
        `).join('');

        return `
            <div class="flex flex-col bg-white border border-n100 rounded-lg p-7 shadow-sm animate-fadeUp">
                <div class="w-[52px] h-[52px] rounded-md bg-creme border border-n100 flex items-center justify-center text-sunset-dark mb-5">
                    <i data-lucide="${escapeHtml(item.icon)}" stroke-width="1.5" class="w-6 h-6"></i>
                </div>
                <h3 class="text-[19px] leading-[1.3] font-semibold text-graphite mb-3">${escapeHtml(item.name)}</h3>
                <p class="text-[15px] leading-relaxed text-n500 flex-grow">${escapeHtml(item.description)}</p>
                ${linksHtml ? `<div class="flex flex-wrap gap-4 pt-4 mt-4 border-t border-n100">${linksHtml}</div>` : ''}
            </div>
        `;
    }).join('');

    root.innerHTML = `
        ${sectionHeader(projects.kicker, projects.heading)}
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            ${itemsHtml}
        </div>
    `;
}
